<template>
  <div class="divide-y divide-gray-200">
    <MobileCRMDetailRow
      v-for="(crmAction, index) in orderedActions"
      :key="crmAction.id"
      :crmAction="crmAction"
      :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-100'"
    />
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { sortCRMDetailsByResolvedDate, sortCRMDetailsByDueDate } from '@/composables/CompanyCRMTools';
import MobileCRMDetailRow from '@/components/mobile/company/MobileCRMDetailRow.vue';

const props = defineProps({
  company: Object
})

const campaignActions = computed(() => {
  const campaign = props.company.campaign
  if (!campaign || !props.company.crm_actions) {
    return []
  }
  return props.company.crm_actions.filter(action => action.campaign_id == campaign.id)
})

const orderedActions = computed(() => [
  ...campaignActions.value.filter(action => !action.resolved_date).sort(sortCRMDetailsByDueDate),
  ...campaignActions.value.filter(action => action.resolved_date).sort(sortCRMDetailsByResolvedDate),
])
</script>
